<template>
	<v-container fluid>
		<v-layout row wrap>
			<v-flex xs12>
				<v-btn class="ml-0" color="success" @click="addClick">
					<v-icon small>fa-plus</v-icon>&nbsp;&nbsp;{{ $t('buttons.add') }}
				</v-btn>
			</v-flex>
		</v-layout>
		<v-layout row wrap>
			<v-flex xs12>
				<v-card class="elevation-0 background-transparent">
					<DataTable
						:excel="false"
						:headers="languagesTable.headers"
						:items="languagesTable.items"
						:total="languagesTable.total"
						@excel="excelExport"
						@reload="reloadData"
					>
						<template #row="props">
							<tr :class="{'cursor-pointer': true}" @contextmenu.prevent="editClick(props.item.id, true)">
								<td @click="editClick(props.item.id, false)">{{ props.item.name }}</td>
								<td>
									<v-tooltip bottom>
										<v-btn @click="editClick(props.item.id, true)" icon slot="activator">
											<v-icon small>fa-external-link-alt</v-icon>
										</v-btn>
										<span>{{$t('tooltips.openInNewTab')}}</span>
									</v-tooltip>
								</td>
							</tr>
						</template>
					</DataTable>
				</v-card>
			</v-flex>
		</v-layout>
	</v-container>
</template>

<script>
import DataTable from "./trinkets/DataTable";

export default {
	name: "Languages",
	components: {DataTable},
	data: function () {
		return {
			languagesTable: {
				headers: [
					{text: this.$t('fields.name'), value: 'name', type: 'string', searchable: 'hidden'},
					{
						text: '',
						value: 'actions',
						type: '',
						sortable: false,
						align: "right",
						width: "100px",
						searchable: false
					}
				],
				items: [],
				total: 0,
				lastRequest: null
			},

		}
	},
	methods: {
		addClick() {
			this.$router.push('/languages/0')
		},
		editClick(id, newTab = false) {
			if (!newTab) {
				this.$router.push('/languages/' + id)
			} else {
				let routeData = this.$router.resolve('/languages/' + id);
				window.open(routeData.href, '_blank');
			}
		},
		reloadData(request) {
			this.lastRequest = request;
			let vm = this;
			this.$APICall('get', 'languages', request, (data, success) => {
				if (success) {
					vm.languagesTable.items = data.items;
					vm.languagesTable.total = data.total;
				} else {
					vm.$alert(vm.$t('alerts.basicError'));
				}
			}, false);
		},
		excelExport() {
			let excelRequest = JSON.parse(JSON.stringify(this.lastRequest));
			excelRequest.pagination.rowsPerPage = 999999999;
			excelRequest.pagination.page = 1;

			let vm = this;
			this.$APICall('get', 'languages', excelRequest, (data, success) => {
				if (success) {
					vm.$APICall('post', 'excel/languages', data.items, (data, success) => {
						window.open(data.link);
					});
				} else {
					vm.$alert(vm.$t('alerts.basicError'));
				}
			}, false);
		}
	},
	mounted() {
		if (!this.$myStore.state.loggedIn) {
			this.$router.replace('login');
		}
		this.$setSubMenu('Settings');
		this.$myStore.commit('setBreadcrumbs', [
			{text: this.$t('modules.languages'), href: '/#/languages', disabled: true}
		]);
	}
}
</script>

<style scoped>

</style>
